// extracted by mini-css-extract-plugin
export default {"card":"update-user_card__cklas","input":"update-user_input__zrNzr","button":"update-user_button__RCNLJ"};